import React, { useState, useEffect } from 'react';
import { listenToPlatformSettings, savePlatformSettings } from '../services/firebase';
import toast from 'react-hot-toast';

const DEFAULT_TIERS = [
  { maxMeters: 500, fee: 20 },
  { maxMeters: 1000, fee: 30 },
  { maxMeters: 2000, fee: 40 },
  { maxMeters: 3000, fee: 50 },
];

export default function Settings() {
  const [form, setForm] = useState({
    maxOrderTotal: 1000,
    serviceRadiusKm: 3,
    storeLat: 13.6561836,
    storeLng: 78.9397511,
    deliveryFeeTiers: DEFAULT_TIERS,
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => listenToPlatformSettings(setForm), []);

  const setTier = (idx, field, value) => {
    const tiers = [...form.deliveryFeeTiers];
    tiers[idx] = { ...tiers[idx], [field]: Number(value) };
    setForm({ ...form, deliveryFeeTiers: tiers });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await savePlatformSettings(form);
      toast.success('Platform settings saved');
    } catch (e) {
      toast.error(e.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Platform Settings</div>
        <div style={{ fontSize: 13, color: 'var(--text2)' }}>Firestore config/platform — no deploy needed</div>
      </div>

      <div className="table-card" style={{ padding: 24, maxWidth: 560 }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 11, color: 'var(--text2)', fontFamily: 'JetBrains Mono', display: 'block', marginBottom: 6 }}>MAX ORDER TOTAL (₹)</label>
          <input type="number" value={form.maxOrderTotal} onChange={(e) => setForm({ ...form, maxOrderTotal: Number(e.target.value) })} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 11, color: 'var(--text2)', fontFamily: 'JetBrains Mono', display: 'block', marginBottom: 6 }}>SERVICE RADIUS (km)</label>
          <input type="number" step="0.1" value={form.serviceRadiusKm} onChange={(e) => setForm({ ...form, serviceRadiusKm: Number(e.target.value) })} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text2)', fontFamily: 'JetBrains Mono', display: 'block', marginBottom: 6 }}>STORE LAT</label>
            <input type="number" step="any" value={form.storeLat} onChange={(e) => setForm({ ...form, storeLat: Number(e.target.value) })} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text2)', fontFamily: 'JetBrains Mono', display: 'block', marginBottom: 6 }}>STORE LNG</label>
            <input type="number" step="any" value={form.storeLng} onChange={(e) => setForm({ ...form, storeLng: Number(e.target.value) })} />
          </div>
        </div>

        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, color: 'var(--text2)', fontFamily: 'JetBrains Mono', marginBottom: 10 }}>DELIVERY FEE TIERS</div>
          {form.deliveryFeeTiers.map((tier, i) => (
            <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 8 }}>
              <input type="number" placeholder="Max meters" value={tier.maxMeters} onChange={(e) => setTier(i, 'maxMeters', e.target.value)} />
              <input type="number" placeholder="Fee ₹" value={tier.fee} onChange={(e) => setTier(i, 'fee', e.target.value)} />
            </div>
          ))}
        </div>

        <button type="button" className="btn btn-green" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : 'Save settings'}
        </button>
      </div>
    </div>
  );
}
